// assets/js/controllers/image-cropper_controller.ts
import { Controller } from '@hotwired/stimulus';
import Cropper from 'cropperjs';
import Swal from 'sweetalert2';

export default class extends Controller {
    static targets = ['input', 'preview'];

    declare readonly inputTarget: HTMLInputElement;
    declare readonly previewTarget: HTMLImageElement;

    async previewImage(event: Event): Promise<void> {
        const input = event.target as HTMLInputElement;

        if (!input.files || input.files.length === 0) {
            return;
        }

        const file = input.files[0];

        if (!file.type.startsWith('image/')) {
            return;
        }

        const objectUrl = URL.createObjectURL(file);
        let cropper: Cropper | null = null;

        const result = await Swal.fire({
            title: 'Recortar imagen',
            html: `
                <div style="max-height: 65vh;">
                    <img id="cropper-image" src="${objectUrl}" style="max-width: 100%; display: block;">
                </div>
            `,
            width: 600,
            showCancelButton: true,
            confirmButtonText: 'Aplicar recorte',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#0d6efd',
            focusConfirm: false,
            didOpen: () => {
                const image = document.getElementById('cropper-image') as HTMLImageElement;
                cropper = new Cropper(image, {
                    aspectRatio: 1,
                    viewMode: 1,
                    autoCropArea: 1,
                    background: false,
                    responsive: true,
                });
            },
            preConfirm: () => {
                if (!cropper) {
                    return null;
                }

                const canvas = cropper.getCroppedCanvas({
                    width: 800,
                    height: 800,
                    imageSmoothingQuality: 'high',
                });

                return new Promise<Blob | null>((resolve) => {
                    canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.9);
                });
            },
            willClose: () => {
                cropper?.destroy();
                cropper = null;
                URL.revokeObjectURL(objectUrl);
            },
        });

        if (!result.isConfirmed || !(result.value instanceof Blob)) {
            // Recorte cancelado: limpiamos la selección para evitar subir el original sin recortar.
            this.inputTarget.value = '';
            return;
        }

        const blob = result.value;
        const baseName = file.name.replace(/\.[^.]+$/, '');
        const croppedFile = new File([blob], `${baseName}.jpg`, { type: 'image/jpeg' });

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(croppedFile);
        this.inputTarget.files = dataTransfer.files;

        this.previewTarget.src = URL.createObjectURL(blob);
    }
}
